import {
    selectEmbeddedAppAlerts,
    selectEmbeddedAppState,
} from 'embedded/store/embeddedAppStateSlice';
import { useSelector } from 'react-redux';
import { useAppSelector } from 'store/hooks.ts';

export const useEmbeddedAppAlerts = () => useSelector(selectEmbeddedAppAlerts);

export const useStylesheetUrl = () =>
    useAppSelector((s) => selectEmbeddedAppState(s).stylesheetUrl);

export const useHostBorderPx = () =>
    useAppSelector((s) => selectEmbeddedAppState(s).hostBorderPx ?? 0);
